import { render } from "./PaymentCard.vue?vue&type=template&id=0b1b4088&scoped=true"
import script from "./PaymentCard.vue?vue&type=script&lang=js"
export * from "./PaymentCard.vue?vue&type=script&lang=js"

import "./PaymentCard.vue?vue&type=style&index=0&id=0b1b4088&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1b4088"]])

export default __exports__